import { createSelector } from 'reselect';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';

export const getTulipsSmartFillApiDomain = (state) => state.getIn(['config', 'tulipsSmartFillApiUrl']);

export const getTulipsSmartFillAPIUrl = createSelector(
  getTulipsSmartFillApiDomain,
  (smartFillAPIUrl) => `${smartFillAPIUrl}/tulips/rds-smartfill`
);

export const getLxpSmartFillApiDomain = (state) => state.getIn(['config', 'V2IzLxpSmartFillApiDomain']);

export const getCarSmartFillUrl = createSelector(
  getLxpSmartFillApiDomain,
  (smartFillAPIUrl) => `${smartFillAPIUrl}/car/smartfill`
);

export const getHotelSmartFillUrl = createSelector(
  getLxpSmartFillApiDomain,
  (smartFillAPIUrl) => `${smartFillAPIUrl}/hotel/smartfill`
);

export const getAirSmartFillUrl = createSelector(
  getLxpSmartFillApiDomain,
  (smartFillAPIUrl) => `${smartFillAPIUrl}/air/smartfill`
);

export const getApigeeSelector = (state) => state.getIn(['config', 'apigeeDomain']);

export const getRecentSearchAPIUrl = createSelector(
  getApigeeSelector,
  (apigeeDomain) => `${apigeeDomain}/travel/v2/travel_services/context/inquiry_results`
);

export const getClearHistoryAPIUrl = createSelector(
  getApigeeSelector,
  (apigeeDomain) => `${apigeeDomain}/travel/v2/travel_services/context`
);

export const getBookingLocationApiBaseUrl = (state) => state.getIn(['config', 'bookingLocationApiBaseUrl']);

export const getBookingLocationAPIUrl = createSelector(
  getBookingLocationApiBaseUrl,
  getActiveLocaleSelector,
  (hotelBookingApiUrl, activeLocale) => `${hotelBookingApiUrl}/${activeLocale.toLowerCase()}`
);
